import SEO from "components/seo";
import Home from "containers/homev1/homev1";

export default function HomePage() {
  return (
    <>
      <SEO />
      <Home />
    </>
  );
}
